// eslint-disable-next-line import/default
import React, { useEffect, useState } from 'react'
import { UserInfo, UserLoginLink } from '@betterplace/design-system/page-parts'

/**
 * @typedef {Object} User
 * @property {string} username
 * @property {string} name
 * @property {string} avatar_url
 * @property {Array<{href: string, name: string}>} links
 */
/**
 * @param {string} loginInfoUrl
 * @returns {{user: User | null, loading: boolean, error: any}}
 */
function useUser(loginInfoUrl) {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)
  const [error, setError] = useState(null)
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(loginInfoUrl, { withCredentials: true, maxRedirects: 0 })
        if (!response.ok) {
          throw new Error(response.statusText)
        }
        const data = await response.json()
        let nextUser = null
        if (data) {
          const { username, name, avatar_url: avatar, links } = data
          if (username) {
            nextUser = { username, name, avatar, links }
          }
        }
        setUser(nextUser)
      } catch (error) {
        setError(error)
      } finally {
        setLoading(false)
      }
    }
    void fetchUser().then()
  }, [loginInfoUrl])
  return { user, loading, error }
}

/**
 * @param {Object} props
 * @param {string} props.loginInfoUrl
 * @param {string} props.loginUrl
 * @param {string} props.label
 * @param {string} props.myProfile
 */
export default function User({ loginInfoUrl, loginUrl, label, myProfile }) {
  const { user } = useUser(loginInfoUrl)
  if (!user) {
    return React.createElement(UserLoginLink, { text: { loginUrl, label } })
  }
  return React.createElement(UserInfo, { text: { ...user, myProfile } })
}
